import React from 'react';

// Material UI
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Imagen1 from "../../../../../assets/default-product.png";

// Iconos
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import useStyles from './styles';
import { utils } from '../../../../../utils/utils';
import { Button } from '@mui/material';

const PurchaseItem = ({ item, warehouseName, currency, onDelete, onRemove, onAdd, onEditPrice, disabled }) => {
    const { classes } = useStyles();
    return (
        <Grid container alignItems='flex-start' className={disabled && classes.itemDisabled}>
            <Grid className={classes.itemImage}>
                <img src={item.imageUrl || Imagen1} className={classes.itemImage} alt={item.description} />
            </Grid>
            <Grid size="grow">
                <Grid container spacing={1} alignItems='baseline' justifyContent='flex-start'>
                    <Grid size={7}>
                        <Typography component='span' variant='body1'>
                            <strong>{item.description}</strong>
                        </Typography>
                        <Typography component='span' variant='caption' display='block'>
                            {item.refId}
                        </Typography>
                        <Typography component='span' variant='subtitle1'>
                            <strong>{warehouseName}</strong>
                        </Typography>
                    </Grid>
                    <Grid size={5}>
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                <Grid container alignItems='center' justifyContent='space-between'>
                                    <Grid>
                                        <IconButton 
                                            disabled={disabled}
                                            size='small' 
                                            className={classes.iconDelete}
                                            onClick={() => { 
                                                if(item.quantity === 1 ) onDelete(item)
                                                else onRemove(item) 
                                            }}
                                        >
                                            { item.quantity === 1 ? <DeleteIcon /> : <RemoveIcon /> }
                                        </IconButton>
                                    </Grid>
                                    <Grid>
                                        <Chip className={classes.itemQuantity} color='primary' size='small' id='product-quantity-chip' label={item.quantity} />
                                    </Grid>
                                    <Grid>
                                        <IconButton
                                            disabled={disabled}
                                            size='small' 
                                            className={classes.iconAdd}
                                            onClick={() => onAdd(item)}
                                        >
                                            <AddIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={12}>
                                <Typography component='span' variant='subtitle2' display='block' align='right'>
                                    {item.quantity} x {currency} {utils.formatMoney(item.unitPrice)}
                                </Typography>
                                {
                                    item.discount > 0 &&
                                    <Typography component='span' variant='subtitle2' display='block' align='right' className={classes.success}>
                                        {currency} {utils.formatMoney(item.discount)}
                                    </Typography>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    {   onEditPrice &&
                        <Grid>
                            <Button
                                fullWidth
                                color="primary"
                                variant='outlined'
                                onClick={() => onEditPrice(item)}
                                size='small'
                                startIcon={<EditIcon fontSize='small' />}
                            >
                                Cambiar
                            </Button>
                        </Grid>
                    }
                    <Grid size="grow">
                        {
                            item.discount > 0 &&
                            <Typography component='span' variant='overline' display='block' align='right'>
                                <Typography component='span' variant='overline' style={{ textDecoration: 'line-through' }}>
                                    {currency} {utils.formatMoney(item.subAmount)}
                                </Typography>
                                <Typography component='span' variant='subtitle1' gutterBottom>
                                    {'\u00A0'} {currency} {utils.formatMoney(item.amount)}
                                </Typography>
                            </Typography>
                        }
                        {
                            item.discount <= 0 &&
                            <Typography component='span' variant='subtitle1' display='block' align='right'>
                                {currency} {utils.formatMoney(item.amount)}
                            </Typography>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default PurchaseItem;